export class ConversationError extends Error {
  constructor(public message: string, public status?: number) {
    super(message);
    this.name = "ConversationError";
  }
}

export class ForbiddenError extends ConversationError {
  constructor(message = "Vous n'avez pas accès à cette conversation") {
    super(message, 403);
    this.name = "ForbiddenError";
  }
}

export class NotFoundError extends ConversationError {
  constructor(message = "Conversation non trouvée") {
    super(message, 404);
    this.name = "NotFoundError";
  }
}

export class ServiceUnavailableError extends ConversationError {
  constructor(message = "Le service est temporairement indisponible") {
    super(message, 503);
    this.name = "ServiceUnavailableError";
  }
}

export interface ErrorResponse {
  detail: string;
}
